// extracted by mini-css-extract-plugin
export default {"wrapper":"EduFormHeader_wrapper__55GMC","form":"EduFormHeader_form__wKUAf"};